import React, { useEffect, useState } from "react";

function FeedbackModal({
  sendFeedback,
  positive_feedback,
  groupFeedback,
  state,
  item,
  handleExpandToggle
}) {
  const [feed, setFeed] = useState(positive_feedback || "");
  console.log("positive_feedback", positive_feedback);
  useEffect(() => {
    if (positive_feedback) {
      setFeed(positive_feedback);
    }
  }, [positive_feedback]);
  return (
    state.feedback_modal && (
      <div className="flex flex-col max-w-[525px] text-[#0F1A24] font-normal text-[14px] font-iner">
        {/* <span className="font-bold">Group:</span> */}
        {/* <textarea
          placeholder={groupFeedback || "Enter Feedback here 😊"}
          defaultValue={groupFeedback || ""}
          disabled={true}
          rows="5"
          cols="40"
          className="h-[108px] border-[1px] border-solid border-[#EAEDF0] p-[10px] mt-[6px] text-[14px]"
        ></textarea> */}
         
        <textarea
          onChange={(e) => setFeed(e.target.value)}
          placeholder="Enter Feedback here 😊"
          value={feed}
          rows="5"
          cols="40"
          className="h-[108px] border-[1px] border-solid border-[#EAEDF0] p-[10px] mt-[6px] text-[14px]"
        ></textarea>
        <button
          className={`max-w-[50%] min-w-[200px] mt-1 py-2 ${
            feed === ""
              ? "bg-[#A9B6C2] text-[#8698A9]"
              : "bg-[#1A91FF] text-[#ffffff]"
          } flex items-center justify-center font-bold`}
          onClick={() => {
            sendFeedback(feed, item.id);
            handleExpandToggle(item, "feedback_modal")
          }}
        >
          Submit
        </button>
      </div>
    )
  );
}

export default FeedbackModal;
